import styled from "styled-components";
import { Container, primaryGreen } from "../../Theme";

const StyledPageHeader = styled.div`
    background-color: ${primaryGreen};
    width: 100%;
`;

const Grid = styled.div`
    display: grid;
    grid-template-columns: 1fr auto 1fr;
    align-items: center;
    gap: 10px;
    min-height: 50px;
    
    @media screen and (max-width: ${props => props.$breakpoint || '425px'})  {
        grid-template-columns: 1fr;
        grid-template-rows: repeat(2, auto);
        gap: 8px;
        padding: 8px 0 8px 0;
    }
`;

export const PageHeader = ({ children, breakpoint, ...props }) => {
    return (
        <StyledPageHeader {...props}>
            <Container>
                <Grid $breakpoint={breakpoint}>
                    {children}
                </Grid>
            </Container>
        </StyledPageHeader>
    );
}

const StyledPageHeaderStart = styled.div`
    justify-self: start;
    grid-column-start: 1;
    
    @media screen and (max-width: ${props => props.$breakpoint || '425px'})  {
        grid-column-start: 1;
        grid-row-start: 2;
    }
`;

PageHeader.Start = function Start({ children, breakpoint, ...props  }) {
    return (
        <StyledPageHeaderStart $breakpoint={breakpoint} {...props}>
            {children}
        </StyledPageHeaderStart>
    );
}

const StyledPageHeaderCenter = styled.div`
    justify-self: center;
    grid-column-start: 2;
    
    @media screen and (max-width: ${props => props.$breakpoint || '425px'})  {
        grid-column-start: 1;
        grid-row-start: 2;
    }
`;

PageHeader.Center = function Center({ children, breakpoint, ...props  }) {
    return (
        <StyledPageHeaderCenter $breakpoint={breakpoint} {...props}>
            {children}
        </StyledPageHeaderCenter>
    );
}

const StyledPageHeaderEnd = styled.div`
    grid-column-start: 3;
    margin-left: auto;
    
    @media screen and (max-width: ${props => props.$breakpoint || '425px'})  {
        grid-column-start: 1;
        grid-row-start: 1;
    }
`;

PageHeader.End = function End({ children, breakpoint, ...props }) {
    return (
        <StyledPageHeaderEnd $breakpoint={breakpoint} {...props}>
            {children}
        </StyledPageHeaderEnd>
    );
}